module.exports = __webpack_public_path__ + "img/democratic-republic-of-congo.e794ff52.png";